import React, { useEffect, useState } from "react";
import {
  // VideoModal,
  VideoIframe,
  ProfileBulletPoints,
  // Breadcrumbs,
  TableAUM,
} from "@hedgefund/shared";
import { useSelector, useDispatch } from "react-redux";
import { 
  Row, 
  Col, 
  Empty, 
  Collapse, 
  // Tabs 
} from "antd";
import {
  getAllocatorDetail, followAllocator, CreateAuditLogs, getAllocatorUsers,
  getHedgeFundUsers, getAdminUsers, createAppointment, showHedgeFundSchedule, getAllocatorInfoAction, getAllocatorUserListAction
} from "./actions";
import jwtDecode from "jwt-decode";
import AllocatorProfileHeader from "@hedgefund/shared/src/AllocatorProfileHeader";
import { RightOutlined } from "@ant-design/icons";
// import { Spinner } from "@public/ui-toolkit";
import { getNumberWithUnit } from "@hedgefund/shared";

const AllocatorDetail = ({ location }) => {
  const [activeKey, setActiveKey] = useState(new Set(['1']));

  let splitId = location.search.split("?allocatorId=");
  const id = splitId[1];

  const allocatorDetailState = useSelector((state) => state.allocatorDetail);
  const { allocatorDetail, allocatorInfo, allocatorUsersList } = allocatorDetailState;

  const dispatch = useDispatch();

  const [followAllocators, setFollowAllocator] = useState(
    allocatorDetail?.followed
  );

  // const allocatorStrategies = allocatorDetail?.allocatorStrategy?.map(
  //   (s) => s?.strategies
  // );

  useEffect(() => {
    dispatch(getAllocatorDetail(id));
    dispatch(showHedgeFundSchedule(id));
    dispatch(getAllocatorInfoAction(id));
    dispatch(getAllocatorUserListAction(id))
    if (Object.keys(allocatorDetail).length !== 0) {
      var values = {
        ownerId: id,
        ownerName: allocatorDetail.name,
        actionName: "Allocator Detail",
        parameters: { id: id, Name: allocatorDetail?.name }
      }
      onCreateAuditLogs(values);
    }
  }, []);

  useEffect(() => {
    allocatorDetail && setFollowAllocator(allocatorDetail?.followed);
  }, [allocatorDetail?.followed]);

  const onSuccess = () => {
    setFollowAllocator(!followAllocators);
  };

  const onClickFollowAllocatorHandler = () => {
    dispatch(followAllocator(id, !followAllocators, onSuccess));
    setFollowAllocator(!followAllocators);
    if (Object.keys(allocatorDetail).length !== 0) {
      var values = {
        ownerId: id,
        ownerName: allocatorDetail.name,
        actionName: "Follow Allocator",
        parameters: { id: id, FollowAllocator: !followAllocators }
      }
      onCreateAuditLogs(values);
    }
  };

  const onCreateAuditLogs = (values) => {
    const user = jwtDecode(localStorage.getItem("token"));
    const auditLog = {
      userId: user?.UserId,
      userName: user?.["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"],
      tenantId: user?.["http://www.aspnetboilerplate.com/identity/claims/tenantId"],
      tenantName: user.TenantName,
      entityId: 0,
      entityName: "",
      entityType: "Hedgefund",
      timeStamp: new Date(),
      ownerId: values.ownerId,
      ownerName: values.ownerName,
      actionName: values.actionName,
      parameters: JSON.stringify(values.parameters)
    }
    dispatch(
      CreateAuditLogs(auditLog)
    );
  }
  const onExpand = (panelKey) => {
    const tempSet = new Set(activeKey);
    if (activeKey.has(panelKey)) {
      tempSet.delete(panelKey);
    } else {
      tempSet.add(panelKey);
    }
    setActiveKey(tempSet);
  };
  return (
    <main>
      <div className="main-inner">
        <Row className="mt-4">
          <Col span={7}>
            <AllocatorProfileHeader
              allocatorId={id}
              AllocatorProfileDetails={allocatorDetailState}
              onClickFollowAllocatorHandler={onClickFollowAllocatorHandler}
              getAllocatorUsers={getAllocatorUsers}
              getHedgeFundUsers={getHedgeFundUsers}
              getAdminUsers={getAdminUsers}
              createAppointment={createAppointment}
              follow={followAllocators}
            />
          </Col>
          <Col span={16} className="ml-3" style={{ backgroundColor: "#fff", borderRadius: "10px", marginLeft: "10px", border: "1px solid #edeef0" }} >
            {/* <div className="mt-4">
            <h2 className="mb-4">Media</h2>
            <VideoModal myFundDetails={allocatorDetail} />
          </div> */}
            <Collapse
              activeKey={Array.from(activeKey)}
              expandIcon={({ isActive, panelKey }) => (
                <RightOutlined
                  onClick={() => onExpand(panelKey)}
                  rotate={isActive ? 90 : 0}
                />
              )}
            >
              <Collapse.Panel key="1" header="My About">
                {/* {allocatorInfoLoading ? (
                  <Row className="text-center">
                    <Col span={24}>
                      <Spinner />
                    </Col>
                  </Row>
                ) : (
                )} */}
                <Row>
                  <Col span={24} className="p-2 ">
                    {/* <div className="rounded-large bg-white border p-2">
                                <h5 data-bs-toggle="tooltip" data-bs-placement="top">
                                  AUM - Assets Under Management 
                                </h5>
                                <div className="table-responsive hf-table-2 "> */}
                    <TableAUM
                      title={"AUM - Assets Under Management"}
                      aum={allocatorDetail?.aum}
                      allocatorInfo={allocatorInfo}
                      editButton={false}
                    />
                  </Col>

                  <Col span={11} className="p-2 ml-1">

                    <ProfileBulletPoints
                      title="Investor Category"
                      editButton={false}
                      description={
                        allocatorDetail?.investorTypeName
                          ? allocatorDetail?.investorTypeName
                          : "No activity found!"
                      }

                    />
                  </Col>
                  <Col span={12} className="p-2 ml-1">
                    <ProfileBulletPoints
                      title="Investor Decision Process"
                      description={
                        allocatorInfo?.idp
                          ? allocatorInfo?.idp
                          : "No activity found!"
                      }
                    />
                  </Col>
                  <Col span={11} className="p-2 ml-1">
                    <ProfileBulletPoints
                      title="Net Dollar Exposure"
                      editButton={false}
                      description={
                        allocatorInfo?.nde === 0
                          ? "No activity found!"
                          : allocatorInfo?.nde
                            ? getNumberWithUnit(allocatorInfo?.nde)
                            : "No activity found!"
                      }
                    />
                  </Col>
                  <Col span={12} className="p-2 ml-1">
                    <ProfileBulletPoints
                      title="Firm Size Interest"
                      editButton={false}
                      description={
                        allocatorInfo?.fsi === 0
                          ? "No activity found!"
                          : allocatorInfo?.fsi
                            ? getNumberWithUnit(allocatorInfo?.fsi)
                            : "No activity found!"
                      }
                    />
                  </Col>
                  <Col span={11} className="p-2 ml-1">
                    <ProfileBulletPoints
                      title="Liquid Strategy Interests"
                      editButton={false}
                      listData={allocatorDetail?.allocatorStrategy?.map((s) => s?.strategies)}
                      stratagiesList={allocatorDetail?.allocatorStrategy?.map((s) => s?.strategies)}
                    />
                  </Col>
                </Row>
              </Collapse.Panel>
              <Collapse.Panel key="2" header="Allocator' Managers">
                <Row gutter={[24,24]} className="bg-white">
                  <Col span={24} className="mt-2 mb-3 ml-2">
                    <h5>Allocator Managers</h5>
                  </Col>
                  {allocatorUsersList?.length > 0 ? (
                    allocatorUsersList?.map((item) => {
                      return (
                        <Col span={7} className="hf-card2 ml-4 mb-3 ">
                            <div
                              className="hf-card2-banner"
                              style={{ cursor: "pointer", marginTop : "180px" }}
                            >
                              <img className="user-Fund-Card" src={item?.profileUrl ? item?.profileUrl : "/assets/images/bg1.png"} alt="Profile Image" />
                            </div>
                            <div className="hf-card-body text-center">
                              <ul className="extra-info mt-3">
                                <li className="mb-2">
                                  <span className="text-dark" style={{ fontSize: "20px", fontWeight: "600", cursor: "pointer" }}>
                                    {item?.fullName}
                                  </span>
                                </li>
                                <li className="mb-2">
                                  {item?.title}
                                </li>
                                <li className="mb-2">
                                  {item?.emailAddress}
                                </li>
                                <li className="mb-2">
                                  <span class="badge badge-secondary p-1 ">Phone :  {item?.phoneNumber}</span>
                                </li>
                              </ul>
                            </div>
                        </Col>
                      )
                    })
                  ) : (
                    <div>
                      <Empty />
                    </div>
                  )}
                </Row>
              </Collapse.Panel>
            </Collapse>
          </Col>
        </Row>
      </div>
      <VideoIframe myFundDetails={allocatorDetail} />
    </main>
  );
};

export default AllocatorDetail;
